<template>
  <div class="crm-management-dashboard">
    <h1>CRM Management Dashboard</h1>
    <!-- Global filters will go here -->
    <GlobalFilterBar
      :base-api="baseApi"
      :access-token="accessToken"
      @filters-changed="handleFiltersChanged"
    />

    <!-- Dashboard sections: single API load; use-aggregate stops each child from calling API -->
     <b-row>
      <b-col cols="12" sm="12" lg="12" v-if="dashboardData && dashboardData.realtime_kpi">
        <RealtimeKpiStrip :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
      </b-col>
      <b-col cols="12" sm="12" lg="12" v-if="dashboardData && dashboardData.presales_pipeline">
        <PresalesPipeline :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" @presales-card-click="handlePresalesDrilldown" />
      </b-col>
      
    </b-row>
    <b-row>
      <b-col cols="6" sm="6" lg="4" v-if="dashboardData && dashboardData.telecaller_leaderboard">
        <TelecallerLeaderboard :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
      </b-col>
      <b-col cols="6" sm="6" lg="4" v-if="dashboardData && dashboardData.sales_manager_leaderboard">
        <SmLeaderboard :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
      </b-col>
      <b-col cols="6" sm="6" lg="4" v-if="dashboardData && dashboardData.lead_source_roi">
        <LeadSourceRoi :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" sm="6" lg="4" v-if="dashboardData && dashboardData.pending_followups">
        <PendingFollowups :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
      </b-col>
      <b-col cols="12" sm="6" lg="4" v-if="dashboardData && dashboardData.upcoming_visits">
        <UpcomingSiteVisits :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
      </b-col>
      <b-col cols="12" sm="6" lg="4">
        <ProjectPerformance :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
      </b-col>
    </b-row>


    
    <b-row>
      <b-col cols="12" md="12">
    <SalesPipeline :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" @sales-card-click="handleSalesDrilldown" />
  </b-col>
  <b-col cols="12" md="6">
    <SalesStageChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
  </b-col>
  <b-col cols="12" md="6">
    <FullFunnelChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
  </b-col>
  </b-row>
<b-row>
      <b-col cols="12" md="6">
        <b-row>
      <b-col cols="12" md="12">
        <MonthlyTrendChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
      </b-col>  
      <b-col cols="12" md="12">
        <ConversionRateChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
      </b-col>
      </b-row>
      </b-col>
      <b-col cols="12" md="6">
        <LeadSourcePieChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="6">
        
        <PresalesDailyChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
      
      </b-col>
      <b-col cols="12" md="6">
        <RevenueTrendChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
      </b-col>
    </b-row>

    <!-- Drill-down Modals -->
    <PresalesDrillModal
      :visible.sync="presalesDrillModalVisible"
      :drilldownLevel="currentDrilldownLevel"
      :filters="filters"
      :leadId="currentLeadId"
      :base-api="baseApi"
      :access-token="accessToken"
    />
    <SalesDrillModal
      :visible.sync="salesDrillModalVisible"
      :drilldownLevel="currentDrilldownLevel"
      :filters="filters"
      :saleId="currentSaleId"
      :base-api="baseApi"
      :access-token="accessToken"
    />

  </div>
</template>

<script>
import GlobalFilterBar from '@/components/dashboard/GlobalFilterBar.vue';
import RealtimeKpiStrip from '@/components/dashboard/RealtimeKpiStrip.vue';
import PresalesPipeline from '@/components/dashboard/PresalesPipeline.vue';
import PresalesDailyChart from '@/components/dashboard/PresalesDailyChart.vue';
import SalesPipeline from '@/components/dashboard/SalesPipeline.vue';
import SalesStageChart from '@/components/dashboard/SalesStageChart.vue';
import FullFunnelChart from '@/components/dashboard/FullFunnelChart.vue';
import ConversionRateChart from '@/components/dashboard/ConversionRateChart.vue';
import LeadSourcePieChart from '@/components/dashboard/LeadSourcePieChart.vue';
import MonthlyTrendChart from '@/components/dashboard/MonthlyTrendChart.vue';
import RevenueTrendChart from '@/components/dashboard/RevenueTrendChart.vue';
import TelecallerLeaderboard from '@/components/dashboard/TelecallerLeaderboard.vue';
import SmLeaderboard from '@/components/dashboard/SmLeaderboard.vue';
import LeadSourceRoi from '@/components/dashboard/LeadSourceRoi.vue';
import PendingFollowups from '@/components/dashboard/PendingFollowups.vue';
import UpcomingSiteVisits from '@/components/dashboard/UpcomingSiteVisits.vue';
import ProjectPerformance from '@/components/dashboard/ProjectPerformance.vue';
import PresalesDrillModal from '@/components/dashboard/PresalesDrillModal.vue';
import SalesDrillModal from '@/components/dashboard/SalesDrillModal.vue';
import { BRow, BCol } from 'bootstrap-vue';
import axios from 'axios';

export default {
  name: 'CrmManagementDashboard',
  components: {
    BRow,
    BCol,
    GlobalFilterBar,
    RealtimeKpiStrip,
    PresalesPipeline,
    PresalesDailyChart,
    SalesPipeline,
    SalesStageChart,
    FullFunnelChart,
    ConversionRateChart,
    LeadSourcePieChart,
    MonthlyTrendChart,
    RevenueTrendChart,
    TelecallerLeaderboard,
    SmLeaderboard,
    LeadSourceRoi,
    PendingFollowups,
    UpcomingSiteVisits,
    ProjectPerformance,
    PresalesDrillModal,
    SalesDrillModal,
  },
  data() {
    return {
      baseApi: process.env.VUE_APP_APIENDPOINT,
      accessToken: localStorage.getItem('accessToken'),
      filters: {}, // Initialize filters
      dashboardData: null, // Single load from /dashboard/crm/all
      presalesDrillModalVisible: false,
      salesDrillModalVisible: false,
      currentDrilldownLevel: '',
      currentLeadId: null,
      currentSaleId: null,
      user: null, // User data for role-based access
      _dashboardFetchTimer: null, // Debounce timer
    };
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.debouncedFetchDashboard();
      },
    },
  },
  methods: {
    handleFiltersChanged(newFilters) {
      this.filters = newFilters;
    },
    debouncedFetchDashboard() {
      if (this._dashboardFetchTimer) clearTimeout(this._dashboardFetchTimer);
      this._dashboardFetchTimer = setTimeout(() => {
        this._dashboardFetchTimer = null;
        this.fetchDashboardData();
      }, 100);
    },
    async fetchDashboardData() {
      if (!this.baseApi || !this.accessToken) return;
      try {
        const response = await axios.get(`${this.baseApi}/dashboard/crm/all`, {
          params: this.filters,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
        });
        if (response.data && response.data.data) {
          this.dashboardData = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        // Keep previous dashboardData so charts/tables don't flash blank
        if (!this.dashboardData) this.dashboardData = {};
      }
    },
    openPresalesDrillModal(level, leadId = null) {
      this.currentDrilldownLevel = level;
      this.currentLeadId = leadId;
      this.presalesDrillModalVisible = true;
    },
    openSalesDrillModal(level, saleId = null) {
      this.currentDrilldownLevel = level;
      this.currentSaleId = saleId;
      this.salesDrillModalVisible = true;
    },
    handlePresalesDrilldown(cardKey) {
      let level = '';
      switch (cardKey) {
        case 'total_leads':
        case 'qualified_interested_leads':
        case 'site_visit_interested':
          level = 'L1'; // Lead-wise details
          break;
        case 'total_calls_done':
        case 'connected_calls':
          level = 'L2'; // Telecaller-wise + Day-wise (followups)
          break;
        default:
          console.warn('Unknown presales card key for drilldown:', cardKey);
          return;
      }
      this.openPresalesDrillModal(level);
    },
    handleSalesDrilldown(cardKey) {
      let level = '';
      switch (cardKey) {
        case 'prospects_received':
        case 'closure_meeting':
        case 'negotiation':
        case 'final_closure_retail':
        case 'final_closure_bulk':
        case 'total_closures':
        case 'closure_value':
        case 'total_bookings_done':
        case 'booking_value':
          level = 'L1'; // Deal-wise details
          break;
        case 'site_visit_done':
          level = 'SITE_VISIT'; // Custom level for site visits
          break;
        // For SM-wise, a dedicated level like 'SM' would be needed once backend is ready
        default:
          console.warn('Unknown sales card key for drilldown:', cardKey);
          return;
      }
      this.openSalesDrillModal(level);
    },
    async fetchUserData() {
      try {
        const response = await axios.get(`${this.baseApi}/user/profile`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
        });
        this.user = response.data.user;
      } catch (error) {
        console.error('Error fetching user data:', error);
        // Fallback: use userData from localStorage if available
        try {
          const userData = JSON.parse(localStorage.getItem('userData') || '{}');
          this.user = userData && Object.keys(userData).length ? userData : { role: 'admin', userrights: [{ module: 'dashboard', all_data: 1 }] };
        } catch (e) {
          this.user = { role: 'admin', userrights: [{ module: 'dashboard', all_data: 1 }] };
        }
      }
    },
  },
  mounted() {
    this.fetchUserData();
    // Single dashboard fetch: after nextTick GlobalFilterBar will have emitted initial filters, then one fetch runs
    this.$nextTick(() => {
      this.debouncedFetchDashboard();
    });
  },
  beforeDestroy() {
    if (this._dashboardFetchTimer) clearTimeout(this._dashboardFetchTimer);
  },
};
</script>

<style scoped>
.crm-management-dashboard {
  /* Basic styling for the dashboard container */
  padding: 20px;
}
</style>